// extracted by mini-css-extract-plugin
module.exports = {"layoutLite":"agenda-session_layoutLite__qpoAq"};